import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import tagColor from 'webapp/helpers/tag-color';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerContextComponent from 'webapp/components/popup/inner/context';

export default class TagColorsContextComponent extends PopupInnerContextComponent<PopupData.Tag.Colors> {
	@service('constants') declare constantsService: Service.Constants;

	get colors() {
		return this.constantsService.tagColors;
	}

	@action
	chooseColor(color: string): void {
		this.popupData.onChoice(color);
		this.close();
	}
	<template>
		<div class="context-ct">
			<div class="title">Select tag color</div>
			<ul>
				{{#each this.colors as |color|}}
					<li>
						<a role="button" {{on "click" (fn this.chooseColor color)}}>
							<CommonUiIconComponent
								@name="TagFill"
								@size="xs"
								@fill={{tagColor color}}
							/>
						</a>
					</li>
				{{/each}}
			</ul>
		</div>
	</template>
}
